<template>
    <div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
    <h1 class="page-header">
        Dashboard Keys Usb
    </h1>
    <div id="loading">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
    </div>
    <div id="no-summary"></div>
    <div id="emptyMessage" style="display:none;">
        <div class="alert alert-info">
            No campaigns created yet. Let's create one!
        </div>
    </div>
    
    <div id="dashboard">
        
        <div class="row">
            <div id="overview_chart_bar" style="height:350px;" class="col-lg-12 col-md-12 col-sm-12 col-xs-12"></div>
        </div>
        <br>

<!--
        <div class="row">
            <div style="height:200px;" class="col-lg-1 col-md-1"></div>
            <div id="sent_chart" style="height:200px;" class="col-lg-2 col-md-2">sent_char</div>
            <div id="returned_chart" style="height:200px;" class="col-lg-2 col-md-2">returned_chart</div>
            <div style="height:200px;" class="col-lg-1 col-md-1"></div>
        </div>
-->

        <div class="row">
            <div class="container-general-stats">
                <div class="stats-title">Global stats</div>
               
                <div class="stat-box green">
                    <img src="../assets/images/stats/-usb-stick_86869.png" alt="Keys sent icon">
                    <div>
                        <div class="stat-percentage" id="generalStat_keysSent">-</div>
                        <div class="stat-description">Keys distributed</div>
                    </div>
                </div>
                <div class="stat-box green">
                    <img src="../assets/images/stats/-usb-stick_86869.png" alt="Keys sent icon">
                    <div>
                        <div class="stat-percentage" id="generalStat_keysReturned">-</div>
                        <div class="stat-description">Keys returned</div>
                    </div>
                </div>
            </div>
        </div>


       


        <div class="row">
            <h2>Recent Campaigns Usb</h2>
        </div>
        <div class="row">
            <a href="/campaignsUsb">
                <button type="button" class="btn btn-primary">View All</button>
            </a>
        </div>
        &nbsp;&nbsp;
        <div class="row">
            <table id="campaignUsbTable" class="table">
                <thead>
                    <tr>
                        <th class="col-md-2 col-sm-2">Name</th>
                        <th class="col-md-2 col-sm-2">Created Date</th>
                        <th class="col-md-1 col-sm-1">
                            <i class="fa fa-send"></i>
                        </th>
                        <th class="col-md-1 col-sm-1">
                            <i class="fa fa-bug"></i>
                        </th>
                        <th class="col-md-1 col-sm-1">Customer</th>
                        <th class="col-md-1 col-sm-1">Status</th>
                        <th class="col-md-2 col-sm-2 no-sort"></th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
    </div>
</div>
      
</template>


<script>

export default {

  name: 'DashboardComponentUsb',

  //props: {

  //  msg: String

  //}

  mounted() {

      let customScript = document.createElement('script')

      customScript.setAttribute('src', '/scripts/dashboardUsb.js')

      customScript.setAttribute('type', 'application/javascript')

      document.head.appendChild(customScript)

      let customScript2 = document.createElement('script')

        customScript2.setAttribute('src', '/scripts/utils.js')

        customScript2.setAttribute('type', 'application/javascript')

        document.head.appendChild(customScript2)
    }

 

}

</script>


<style>

</style>